// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"276ba9ec","14":"7b592b69","38":"43ad1ac2","134":"ca4c35d5","449":"2620ba9d","617":"862057fd","659":"9e4659de","758":"1c976e2f","778":"e23ddd96","912":"d3e96715"}[chunkId] + ".chunk.js";
};